import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { Lightbox } from '@ngx-gallery/lightbox';
import { Gallery } from '@ngx-gallery/core';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class GalleryComponent implements OnInit {

  @Input() images;
  @Input() category = '';
  galleryId = 'imageGallery';

  constructor(
    private readonly lightbox: Lightbox,
    public readonly gallery: Gallery,
  ) {
    this.gallery.ref(this.galleryId);
  }

  ngOnInit() {
  }

  openInFullScreen(index) {
    this.lightbox.open(index, this.galleryId, {
    });
  }
}
